import type { FC } from 'react'
import { CheckCircleOutlined } from '@ant-design/icons'
import { Box, Button, Stack, Typography, useTheme } from '@mui/material'
import Paper from 'components/@extended/Paper'

interface SmartImportSummaryProps {
  categoriesCount: number
  rewardsCount: number
  onViewRewards: () => void
}

const SmartImportSummary: FC<SmartImportSummaryProps> = ({ categoriesCount, rewardsCount, onViewRewards }) => {
  const theme = useTheme()
  const categoryLabel = categoriesCount === 1 ? 'category' : 'categories'
  const rewardLabel = rewardsCount === 1 ? 'reward' : 'rewards'

  return (
    <Paper sx={{ p: { xs: 2.5, md: 3 }, width: '100%' }}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <CheckCircleOutlined style={{ color: theme.palette.success.main, fontSize: 22 }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Import complete
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {rewardsCount} {rewardLabel} approved across {categoriesCount} {categoryLabel}.
            </Typography>
          </Box>
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="flex-end">
          <Button variant="contained" onClick={onViewRewards}>
            Go to rewards
          </Button>
        </Stack>
      </Stack>
    </Paper>
  )
}

export default SmartImportSummary
